/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ConnectionInfo } from './ConnectionInfo';
import {
    ConnectionInfoFromJSON,
    ConnectionInfoFromJSONTyped,
    ConnectionInfoToJSON,
} from './ConnectionInfo';

/**
 * 
 * @export
 * @interface MonitoringWellTreeView
 */
export interface MonitoringWellTreeView {
    /**
     * 
     * @type {number}
     * @memberof MonitoringWellTreeView
     */
    id?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    name?: string;
    /**
     * 
     * @type {number}
     * @memberof MonitoringWellTreeView
     */
    itemOrder?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    status?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    wellprofileType?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    extendedStatus?: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    comment?: string;
    /**
     * 
     * @type {boolean}
     * @memberof MonitoringWellTreeView
     */
    isHidden?: boolean;
    /**
     * 
     * @type {number}
     * @memberof MonitoringWellTreeView
     */
    projectId?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    projectTitle: string;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    padTitle: string;
    /**
     * 
     * @type {number}
     * @memberof MonitoringWellTreeView
     */
    fieldId?: number;
    /**
     * 
     * @type {string}
     * @memberof MonitoringWellTreeView
     */
    fieldTitle: string;
    /**
     * 
     * @type {Array<ConnectionInfo>}
     * @memberof MonitoringWellTreeView
     */
    connections?: Array<ConnectionInfo>;
}

/**
 * Check if a given object implements the MonitoringWellTreeView interface.
 */
export function instanceOfMonitoringWellTreeView(value: object): value is MonitoringWellTreeView {
    if (!('projectTitle' in value) || value['projectTitle'] === undefined) return false;
    if (!('padTitle' in value) || value['padTitle'] === undefined) return false;
    if (!('fieldTitle' in value) || value['fieldTitle'] === undefined) return false;
    return true;
}

export function MonitoringWellTreeViewFromJSON(json: any): MonitoringWellTreeView {
    return MonitoringWellTreeViewFromJSONTyped(json, false);
}

export function MonitoringWellTreeViewFromJSONTyped(json: any, ignoreDiscriminator: boolean): MonitoringWellTreeView {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'name': json['name'] == null ? undefined : json['name'],
        'itemOrder': json['itemOrder'] == null ? undefined : json['itemOrder'],
        'status': json['status'] == null ? undefined : json['status'],
        'wellprofileType': json['wellprofileType'] == null ? undefined : json['wellprofileType'],
        'extendedStatus': json['extendedStatus'] == null ? undefined : json['extendedStatus'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'isHidden': json['isHidden'] == null ? undefined : json['isHidden'],
        'projectId': json['projectId'] == null ? undefined : json['projectId'],
        'projectTitle': json['projectTitle'],
        'padTitle': json['padTitle'],
        'fieldId': json['fieldId'] == null ? undefined : json['fieldId'],
        'fieldTitle': json['fieldTitle'],
        'connections': json['connections'] == null ? undefined : ((json['connections'] as Array<any>).map(ConnectionInfoFromJSON)),
    };
}

export function MonitoringWellTreeViewToJSON(value?: MonitoringWellTreeView | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'id': value['id'],
        'name': value['name'],
        'itemOrder': value['itemOrder'],
        'status': value['status'],
        'wellprofileType': value['wellprofileType'],
        'extendedStatus': value['extendedStatus'],
        'comment': value['comment'],
        'isHidden': value['isHidden'],
        'projectId': value['projectId'],
        'projectTitle': value['projectTitle'],
        'padTitle': value['padTitle'],
        'fieldId': value['fieldId'],
        'fieldTitle': value['fieldTitle'],
        'connections': value['connections'] == null ? undefined : ((value['connections'] as Array<any>).map(ConnectionInfoToJSON)),
    };
}

